import StatusScreenScaffold from "../../../../components/layout/StatusScreenScaffold";
import { StatusScreenType } from "../../../../components/layout/StatusScreenScaffold/types";

function ProposalDone() {
  return (
    <StatusScreenScaffold
      title="Proposta efetivada!"
      subtitle="A proposta foi efetivada com sucesso"
      subtitleMaxWidth={240}
      type={StatusScreenType.info}
    />
  );
}

export default ProposalDone;
